export default class QuotingRules {
  constructor(rules) {
    this.rules = rules;
  }
}
